import React, { Component } from 'react'
import Preview from '../Preview'
import Code from '../Code'
import Block from '../../../../src/components/Block'
import { formatCode, prefixCode } from '../Code/utils'
import styles from './Demo.css'

export default class Demo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      code: props.example.source
    }
    this.editor = null
  }
  componentDidMount() {
    // alert('mounted')
  }
  resetOriginalCode = () => {
    const { name } = this.props
    const originalCode = this.props.example.source
    const formattedCode = formatCode(originalCode)
    const displayCode = prefixCode(name, formattedCode)
    this.editor.setValue(displayCode)
  }
  editorDidMount = (editor, next) => {
    this.editor = editor
  }
  handleCodeChange = (editor, data, value) => {
    const newCode = editor.getValue()
    console.log('newCode', newCode)
    console.log('line count', editor.lineCount())
    this.setState({
      code: newCode
    })
  }
  render () {
    const { example, name } = this.props
    const { code } = this.state

    return (
      <div className={styles.demo}>
        <div className={styles.preview}>
          <h2>Live Preview</h2>
          <Block>
            <Preview
              code={code}
              path={example.path}
              reset={this.resetOriginalCode}
            />
          </Block>
        </div>
        <div className={styles.code}>
          <h2>Code</h2>
          <Code
            originalCode={this.props.example.source}
            code={this.props.example.source}
            name={name}
            editorDidMount={this.editorDidMount}
            onChange={this.handleCodeChange} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Demo/index.js